<template>
  <div :class="['cmp', 'cmp-tab-baseinfo']">
    <el-row type="flex">
      <div class="baseinfo-label">项目封面</div>
      <div class="baseinfo-content">
        <img class="project-cover" :src="projectDetails.cover">
        <!-- <img class="project-cover" :src="resourceInfoDict[projectDetails.cover]"> -->
      </div>
    </el-row>
    <el-row type="flex">
      <div class="baseinfo-label">教材</div>
      <div class="baseinfo-content">
        {{projectDetails.name}} > {{projectDetails.unitName}}
      </div>
    </el-row>
    <el-row type="flex">
      <div class="baseinfo-label">说明</div>
      <div class="baseinfo-content">
        {{projectDetails.description}}
      </div>
    </el-row>
  </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'
import publicUrl from '@/assets/js/interface'

export default {
  name: 'cmp-tab-baseinfo',
  data () {
    return {
      projectDetails: {}
    }
  },
  computed: {
    ...mapState({
      resourceInfoDict: 'resourceInfoDict',
    }),
  },
  mounted () {
    this.getProjectDetails()
  },
  methods: {
    ...mapMutations(['setResourceInfoDict']),
    ...mapActions(['resourceInfoGetter']),
    getProjectDetails () {
      this.loadingCount++
      this.projectDetails = {}
      this.$ajax.get(publicUrl.projectDetails, {
        params: {
          projectId: this.$route.query.projectId,
        }
      }).then(res => {
        if (res.data.code === 0) {
          this.projectDetails = (res.data.data || {})
          // let fileNames = [ this.projectDetails.cover ].filter(v => !!v)
          // this.resourceInfoGetter({vm: this.$root, fileNames})
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$ajaxError(err)
      }).finally(() => {
        this.loadingCount--
      })
    },
  }
}
</script>

<style lang="less" scoped>
.cmp-tab-baseinfo {
  line-height: 30px;
  .el-row {
    margin-bottom: 15px;
  }
  .baseinfo-label {
    width: 4.5em;
    margin-right: 2em;
    font-size: 20px;
    font-weight: 600;
    color: #464C5B;
    text-align-last: justify;
  }
  .baseinfo-content {
    width: 0;
    flex-grow: 1;
    font-size: 16px;
    color: #657180;
    .project-cover {
      width: 197px;
      height: 264px;
      object-fit: contain;
      background: #dedede;
    }
  }
}
</style>
